export const menuProfessor = [
  { label: "Minhas disciplinas", path: "/minhas-disciplinas" },
  { label: "Minhas Turmas", path: "/turmas" },
  { label: "Minhas Sessões", path: "/minhas-sessoes" },
  { label: "Checkpoints", path: "/checkpoints" },
  { label: "Meus Dados", path: "/meus-dados" }
];

